export default __webpack_public_path__ + "static/media/screenshot1_sm.561013b9.jpg";